import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import axios from "axios";
import { faChevronRight, faSearch } from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { getUserType } from "../../utils/index";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import SimpleReactValidator from "simple-react-validator";
import GiftVoucherTable from "./GiftVoucherTable";
//import { Chart } from "react-google-charts";
import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { counter } from "@fortawesome/fontawesome-svg-core";
ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// const reportFilterForm = Yup.object().shape({
//   countryId: Yup.string().required("Required"),
//   stateId: Yup.string().required("Required"),
//   districtId: Yup.string().required("Required"),
//   cityId: Yup.string().required("Required"),
// });
const labels = [
  "Expiring in 3 Months",
  "Expiring in 6 Months",
  "Expiring in 9 Months",
  "Expiring in 12 Months",
  "Expiring in over 12 Months",
];

const Checkbox = ({ id, type, name, handleClick, isChecked, attr }) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      onChange={handleClick}
      checked={isChecked}
      data-attr={attr}
    />
  );
};

//['January', 'February', 'March', 'April', 'May', 'June', 'July'];
if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // countryId: Yup.string().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
}

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class GiftVoucherIssueComponent extends React.Component {
  groupId = { value: "" };
  state = {
    selectedStatus: 0,
    landloardArr: [],
    assetArr: [],
    subAssetArr: [],
    towerArr: [],
    companyArr: [],
    cityList: [],
    occupierList: [],
    leaseList: [],
    landloardList: [],
    assetsList: [],
    assetTypeList: [],
    assetTypeSelected: [],
    counter: 0,
    tableTOShow: "RENT",
    companyDetails: {
      companyPan: "",
    },
    formResponseData: [],
    invoiceList: {},
    financialYearOne: '',
    initialValues: {
      assetId: "",
      subAssetName: "",
      subAssetId: "",
      leaseCode: "",
      leaseId: "",
      count: 0,
      financialYearOne: '',
      gcEndNumber: '',
      gcStartNumber: '',
      leaseId: '',
      'rate': '',
      totalAmount: '',
      towerId: '',
      towerName: '',
      validity: '',
      validityCount: '',
      assetTypeId: "",
    },
    notesCount: {
      0: 0,
      1: 0,
      2: 0,
      3: 0,
    },
    datatableList: [],
    totalRows: 0,
    loading: false,
    perPage: 10,
    pageNo: 1,
    showStatusOption: false,
    tableCounter: Math.round(),
    gridColumns: [
      {
        name: "S.No",
        selector: "srNo",
        sortable: false,
        grow: 1,
      },
      {
        name: "Asset Name",
        selector: "lease_id",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Lease Id",
        selector: "lease_id",
        sortable: false,
        grow: 3,
        wrap: true,
      },
      {
        name: "Issued Month",
        selector: "issued_month",
        sortable: false,
        grow: 3,
        wrap: true,
      },

      {
        name: "Total Amt",
        selector: "total_value",
        sortable: false,
        grow: 3,
        wrap: true,
      },
    ]
  };

  componentDidMount() {
    this.initialiseAllData();
  }

  initialiseAllData = () => {
    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
    this.getAssetTypes();
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    this.applicableValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  getAssetTypes = () => {
    let self = this;
    axios({
      method: 'GET',
      url: `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-with-filters?city_id=&brand_ids=`,
      headers: headers
    }).then((response) => {
      self.setState({
        assetTypeList: response.data
      });
    });
  }

  getAssetsListByAssetType = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-asset-lists?asset_type_ids=
      ${this.state.initialValues.assetTypeId}&city_id=&brand_ids=`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };

  handleCalculation = (e, index, values) => {
    var total = 0;
    for (const value in values.amount) {
      total += parseInt(values.amount[value]);
    }
    //console.log(total, "total", this.state.formResponseData[index].variance )
    if (typeof index == "undefined") {
      this.setState({ totalInvoiceAmount: total });
    } else {
      var formData = this.state.formResponseData;
      formData[index].variance =
        parseFloat(formData[index].net_charge_amount) - e.target.value;

      this.setState({ totalInvoiceAmount: total, formResponseData: formData }); //, `formResponseData${}` : totalVariance
    }
  };

  valueChange = (newValue, actionMeta) => {
    this.state.initialValues.assetName ="";
    this.state.initialValues.assetId ="";

      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.assetTypeId.push(newValue[i].value);
        this.state.assetTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByAssetType();
  }

  valueChangeTower = (newValue, actionMeta) => {
    fetch(
      `${apiUrl.apiUrl.url}/asset/get-tower-leases?id=` + newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };


  valueChangeSubAsset = (newValue, actionMeta) => {
    this.state.initialValues.subAssetId = newValue.value;
    this.state.initialValues.subAssetName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          towerArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  valueFrequencyChange = (newValue, actionMeta) => {
    this.state.initialValues.frequencySelected = newValue.value;
    this.setState({});
  };
  valueChangeChargeType = (newValue, actionMeta) => {
    this.state.initialValues.chargeTypeSelected = newValue.value;
    this.state.initialValues.chargeType = newValue.value;
  };

  valueChangeOccupier = (newValue, actionMeta) => {
    this.state.initialValues.occupierId = newValue.value;
    this.state.initialValues.occupierName = newValue.label;
    this.setState({});
    fetch(
      `${apiUrl.apiUrl.url}/asset/get-occupier-leases?id=` +
      newValue.value +
      `&tower=` +
      this.state.initialValues.towerId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "ata");
        this.setState({
          leaseList: data,
        });
        // this.state.initialValues.companyPan = data.data.companyPan;
        // this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChangeCompany = (newValue, actionMeta) => {
    this.state.initialValues.companyId = newValue.value;
    this.state.initialValues.companyName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/landlord/get-company?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "ata");
        this.setState({
          companyDetails: data.data,
        });
        this.state.initialValues.companyPan = data.data.companyPan;
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetId = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    //landlord-group/fetch-landlord-list
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          subAssetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeChk = (val) => {
    console.log(val, "clickec");
  };

  handleChangeLandlord = (newValue, actionMeta) => {
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});

    //landlord-group/fetch-landlord-list
    fetch(
      `${apiUrl.apiUrl.url}/asset/fetch-landlord-all-assets?id=` +
      newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` + newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };
  redirectAfterSave = () => {
    this.setState({
      messsagePopup: false,
      popupMessageContent: "",
    });
  };


  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/reports/gift-vouchers" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {


    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Reports</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>Gift Vouchers</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="javascript:void(0);">
                  Gift Vouchers
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          //validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.financialYearOne = '';
            this.state.counter = Math.random();
            this.setState({});

            this.state.assetTypeSelected = [];
            this.state.initialValues.assetTypeId = [];
            this.initialiseAllData();

          }}
          onSubmit={(values, actions) => {
            var self = this;

            if (!this.applicableValidator.allValid()) {
              this.applicableValidator.showMessages();
              return false;
            }

            console.log(values, "values");
            values.financialYearOne = this.state.initialValues.financialYearOne;

            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/voucher/generate-voucher`,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                self.setState({
                  messsagePopup: true,
                  popupContent: response.data.msg,
                });
                setTimeout(function () {
                  self.setState({});
                });
              } else {
                self.setState({
                  messsagePopup: true,
                  popupContent: "Data Saved Successfully",
                });

                self.state.initialValues = {

                  assetId: "",
                  subAssetName: "",
                  subAssetId: "",
                  leaseCode: "",
                  leaseId: "",
                  count: 0,
                  financialYearOne: '',
                  gcEndNumber: '',
                  gcStartNumber: '',
                  leaseId: '',
                  'rate': '',
                  totalAmount: '',
                  towerId: '',
                  towerName: '',
                  validity: '',
                  validityCount: ''

                };
                //self.setState({ financialYearOne: '' });
                self.state.financialYearOne = '';
                setTimeout(function () {
                  self.setState({});
                });
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                    <div className="newGridSectionInner">
                        <label>Asset Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_type");
                            }}
                            value={this.state.assetTypeSelected}
                            options={this.state.assetTypeList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>

                      {/* Asset Name */}
                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetName"
                            onChange={(e) => {
                              this.valueChangeAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="assetId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Sub Asset Name */}
                      <div className="newGridSectionInner">
                        <label>Sub Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="subAssetName"
                            onChange={(e) => {
                              this.valueChangeSubAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.subAssetName,
                              value: this.state.initialValues.subAssetId,
                            }}
                            options={this.state.subAssetArr.map((item) => ({
                              label: item.sub_asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="subAssetName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Tower Name */}
                      <div className="newGridSectionInner">
                        <label>Tower Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="towerId"
                            onChange={(e) => {
                              this.state.initialValues.towerId = e.value;
                              this.state.initialValues.towerName = e.label;
                              this.valueChangeTower(e);
                            }}
                            value={{
                              label: this.state.initialValues.towerName,
                              value: this.state.initialValues.towerId,
                            }}
                            options={this.state.towerArr.map((item) => ({
                              label: item.tower_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="towerId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Leases */}
                      <div className="newGridSectionInner">
                        <label>Leases<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="occupierId"
                            onChange={(e) => {
                              this.state.initialValues.leaseCode = e.label;
                              this.state.initialValues.leaseId = e.value;
                              this.setState({});
                            }}
                            value={{
                              label: this.state.initialValues.leaseCode,
                              value: this.state.initialValues.leaseId,
                            }}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          {this.applicableValidator.message(
                            "Leases",
                            this.state.initialValues.leaseId,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="occupierId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Issued Month */}
                      <div className="newGridSectionInner">
                        <label>Issued Month <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) =>
                              this.setState({ financialYearOne: date })
                            }
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.financialYearOne,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="financialYearOne"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Validity */}
                      <div className="newGridSectionInner">
                        <label>Validity <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            as="select"
                            name={"validity"}
                            onChange={(e) => {
                              this.state.initialValues.validity = e.target.value;
                              this.setState({});
                              handleChange(e);
                            }}
                          >
                            <option value="" label="Select" defaultValue />
                            <option value="days" label="Days" />
                            <option value="months" label="Months" />
                            <option value="years" label="Years" />
                          </Field>
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.validity,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      {/* Validity Count */}
                      <div className="newGridSectionInner">
                        <label>Validity Count <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            type="number"
                            name="validityCount"
                            value={this.state.initialValues.validityCount}
                            onChange={(e) => {
                              this.state.initialValues.validityCount = e.target.value;
                              this.setState({});
                            }}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.validityCount,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="validityCount"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Rate */}
                      <div className="newGridSectionInner">
                        <label>Rate <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            type="number"
                            name="rate"
                            value={this.state.initialValues.rate}
                            onChange={(e) => {
                              this.state.initialValues.rate = e.target.value;
                              this.state.initialValues.totalAmount = this.state.initialValues.count * e.target.value;
                              this.setState({});
                            }}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.rate,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="rate"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Count */}
                      <div className="newGridSectionInner">
                        <label>Count <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            type="number"
                            name="count"
                            value={this.state.initialValues.count}
                            onChange={(e) => {
                              this.state.initialValues.count = e.target.value;
                              this.state.initialValues.gcEndNumber = Number(e.target.value) + Number(this.state.initialValues.gcStartNumber);
                              this.state.initialValues.totalAmount = this.state.initialValues.rate * e.target.value;
                              this.setState({});
                            }}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.count,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="count"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Total Amount */}
                      <div className="newGridSectionInner">
                        <label>Total Amount <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            type="number"
                            name="totalAmount"
                            value={this.state.initialValues.totalAmount}
                            onChange={(e) => {
                              this.state.initialValues.totalAmount = this.state.initialValues.rate * this.state.initialValues.count;
                              this.setState({});
                            }}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.totalAmount,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="totalAmount"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* GC Start Numbers */}
                      <div className="newGridSectionInner">
                        <label>GC Start Numbers <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            type="number"
                            name="gcStartNumber"
                            value={this.state.initialValues.gcStartNumber}
                            onChange={(e) => {
                              this.state.initialValues.gcStartNumber = e.target.value;
                              this.state.initialValues.gcEndNumber = Number(e.target.value) + Number(this.state.initialValues.count);
                              this.setState({});
                            }}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.gcStartNumber,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="gcStartNumber"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* GC End Numbers */}
                      <div className="newGridSectionInner">
                        <label>GC End Numbers <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Field
                            type="number"
                            name="gcEndNumber"
                            value={this.state.initialValues.gcEndNumber}
                            onChange={(e) => {
                              this.state.initialValues.gcEndNumber = e.target.value;
                              this.setState({});
                            }}
                          />
                          {this.applicableValidator.message(
                            "",
                            this.state.initialValues.gcEndNumber,
                            "required",
                            { className: "text-danger" }
                          )}
                          <ErrorMessage
                            name="gcEndNumber"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                    </div>

                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        Create Voucher
                      </button>
                      <button type="reset" className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>

                </Form>
              </div>

              {/* <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="assetName"
                                onChange={(e) => {
                                  this.valueChangeAsset(e);
                                }}
                                // value={this.state.brandSelected}
                                value={{
                                  label: this.state.initialValues.assetName,
                                  value: this.state.initialValues.assetId,
                                }}
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="assetId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Sub Asset Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="subAssetName"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChangeSubAsset(e);
                                }}
                                value={{
                                  label: this.state.initialValues.subAssetName,
                                  value: this.state.initialValues.subAssetId,
                                }}
                                options={this.state.subAssetArr.map((item) => ({
                                  label: item.sub_asset_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="subAssetName"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Tower Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="towerId"
                                onInputChange={this.handleChange}
                                value={{
                                  label: this.state.initialValues.towerName,
                                  value: this.state.initialValues.towerId,
                                }}
                                onChange={(e) => {
                                  this.state.initialValues.towerId = e.value;
                                  this.state.initialValues.towerName = e.label;
                                  this.valueChangeTower(e);
                                }}
                                //value={this.state.brandSelected}
                                options={this.state.towerArr.map((item) => ({
                                  label: item.tower_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="towerId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Leases<span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                name="occupierId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  //this.valueChangeOccupier(e);
                                  this.state.initialValues.leaseCode = e.label;
                                  this.state.initialValues.leaseId = e.value;
                                  this.setState({});
                                }}
                                value={{
                                  label: this.state.initialValues.leaseCode,
                                  value: this.state.initialValues.leaseId,
                                }}
                                options={this.state.leaseList.map((item) => ({
                                  label: item.lease_code,
                                  value: item.id,
                                }))}
                              />
                              {this.applicableValidator.message(
                                "Leases",
                                this.state.initialValues.leaseId,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="occupierId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Issued Month
                              <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <DatePicker
                                onChange={(date) =>
                                  this.setState({ financialYearOne: date })
                                }
                                onBlur={this.handleCalenderOnBlur}
                                dateFormat="MMMM yyyy"
                                showMonthYearPicker
                                selected={this.state.financialYearOne}
                                onCalendarClose={this.handleCalenderOnBlur}

                              />
                              {this.applicableValidator.message(
                                "",
                                this.state.financialYearOne,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="financialYearOne"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Validity <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field
                                as="select"
                                name={"validity"}
                                onChange={(e) => {
                                  console.log(e, "eee");
                                  this.state.initialValues.validity = e.target.value;
                                  this.setState({});
                                  handleChange(e);
                                }}
                              >
                                <option
                                  value=""
                                  label="Select"
                                  defaultValue
                                />
                                <option
                                  value="days"
                                  label="Days"
                                />
                                <option
                                  value="months"
                                  label="Months"
                                />
                                <option
                                  value="years"
                                  label="Years"
                                />
                              </Field>
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.validity,
                                "required",
                                { className: "text-danger" }
                              )}

                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Validity Count <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="validityCount" value={this.state.initialValues.validityCount} onChange={(e) => {
                                this.state.initialValues.validityCount = e.target.value;
                                this.setState({})
                              }} />
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.validityCount,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="validityCount"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Rate <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="rate" value={this.state.initialValues.rate} onChange={(e) => {
                                this.state.initialValues.rate = e.target.value;
                                this.state.initialValues.totalAmount = this.state.initialValues.count * e.target.value;
                                this.setState({})
                              }} />
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.rate,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="rate"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Count <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="count" value={this.state.initialValues.count} onChange={(e) => {
                                this.state.initialValues.count = e.target.value;

                                this.state.initialValues.gcEndNumber = Number(e.target.value) + Number(this.state.initialValues.gcStartNumber);

                                this.state.initialValues.totalAmount = this.state.initialValues.rate * e.target.value;
                                this.setState({});
                              }} />
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.count,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="count"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Total Amount <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="totalAmount" value={this.state.initialValues.totalAmount} onChange={(e) => {
                                this.state.initialValues.totalAmount = this.state.initialValues.rate * this.state.initialValues.count;
                                this.setState({})
                              }} />
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.totalAmount,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="totalAmount"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              GC Start Numbers <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="gcStartNumber" value={this.state.initialValues.gcStartNumber} onChange={(e) => {
                                this.state.initialValues.gcStartNumber = e.target.value;
                                this.state.initialValues.gcEndNumber = Number(e.target.value) + Number(this.state.initialValues.count);
                                this.setState({})
                              }} />
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.gcStartNumber,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="gcStartNumber"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              GC End Numbers <span className="astrik">*</span>
                            </label>
                            <div className="col-sm-7">
                              <Field type="number" name="gcEndNumber" value={this.state.initialValues.gcEndNumber} onChange={(e) => {
                                this.state.initialValues.gcEndNumber = e.target.value;
                                this.setState({})
                              }} />
                              {this.applicableValidator.message(
                                "",
                                this.state.initialValues.gcEndNumber,
                                "required",
                                { className: "text-danger" }
                              )}
                              <ErrorMessage
                                name="gcEndNumber"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>



                    </div>

                    <div className="row">
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer">
                          <div>
                            <button type="submit" disabled={isSubmitting}>
                              Create Voucher
                            </button>
                            <button type="reset" onClick={this.selectAll}>
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div> */}
            </>
          )}
        </Formik>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>



        <GiftVoucherTable
          key={this.state.counter}
          columns={this.state.gridColumns}
          formConfig={this.state.formConfig}
          fetchUrl={apiUrl.apiUrl.url + "/voucher/fetch-vouchers?"}
          ths={this}
        />

      </>
    );
  }
}

export default withRouter(GiftVoucherIssueComponent);
